<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-40"
      :bodyStyle="{ paddingTop: '12px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="20">
            <h6>Pending Payment</h6>
            <p>Pay your tuition fees with QR code.</p>
          </a-col>
        </a-row>
      </template>
      <!-- components -->
      <div v-if="$store.state.role.RulesUser.roles.includes('student')">
        <feeStd class="mb-20" />
      </div>
    </a-card>
  </div>
</template>

<script>
import feeStd from "./student/fee_std.vue";
export default {
  components: {
    feeStd,
  },
  data() {
    return {};
  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss">
</style>